(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__collageGridLayoutBound) return;
    window.__collageGridLayoutBound = true;

    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const isCollageBlock = (element) => {
      return element.matches('product-card, .image-block, a.image-block, deferred-media, .video-placeholder-wrapper');
    };

    const resetGridPlacement = (blocks) => {
      blocks.forEach((block) => {
        block.style.gridColumn = '';
        block.style.gridRow = '';
      });
    };

    const applyGridPlacement = (grid) => {
      const blocks = Array.from(grid.children).filter(isCollageBlock);
      const layout = grid.dataset.desktopLayout;

      resetGridPlacement(blocks);

      if (!desktopQuery.matches) return;

      if (blocks.length === 1) {
        blocks[0].style.gridColumn = '1 / span 3';
        blocks[0].style.gridRow = '1 / span 2';
        return;
      }

      if (blocks.length === 2) {
        if (layout === 'right') {
          blocks[0].style.gridColumn = '1';
          blocks[0].style.gridRow = '1 / span 2';
          blocks[1].style.gridColumn = '2 / span 2';
          blocks[1].style.gridRow = '1 / span 2';
        } else {
          blocks[0].style.gridColumn = '1 / span 2';
          blocks[0].style.gridRow = '1 / span 2';
          blocks[1].style.gridColumn = '3';
          blocks[1].style.gridRow = '1 / span 2';
        }
        return;
      }

      if (layout === 'right') {
        blocks[0].style.gridColumn = '1';
        blocks[0].style.gridRow = '1';
        blocks[1].style.gridColumn = '1';
        blocks[1].style.gridRow = '2';
        blocks[2].style.gridColumn = '2 / span 2';
        blocks[2].style.gridRow = '1 / span 2';
      } else {
        blocks[0].style.gridColumn = '1 / span 2';
        blocks[0].style.gridRow = '1 / span 2';
        blocks[1].style.gridColumn = '3';
        blocks[1].style.gridRow = '1';
        blocks[2].style.gridColumn = '3';
        blocks[2].style.gridRow = '2';
      }
    };

    const applyAllCollageGrids = (root = document) => {
      root.querySelectorAll('[data-testid="collage-grid"] .collage-grid').forEach((grid) => {
        applyGridPlacement(grid);

        if (!grid.__collageObserver) {
          grid.__collageObserver = new MutationObserver(() => applyGridPlacement(grid));
          grid.__collageObserver.observe(grid, { childList: true });
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => applyAllCollageGrids(), { once: true });
    document.addEventListener('shopify:section:load', (event) => applyAllCollageGrids(event.target));
    document.addEventListener('shopify:section:reorder', () => applyAllCollageGrids());
    document.addEventListener('shopify:block:select', () => applyAllCollageGrids());
    document.addEventListener('shopify:block:deselect', () => applyAllCollageGrids());
    desktopQuery.addEventListener('change', () => applyAllCollageGrids());

    applyAllCollageGrids();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
